import { render } from "./statustag.vue?vue&type=template&id=7ff1094f&scoped=true"
import script from "./statustag.vue?vue&type=script&lang=js"
export * from "./statustag.vue?vue&type=script&lang=js"

import "./statustag.vue?vue&type=style&index=0&id=7ff1094f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff1094f"]])

export default __exports__